module.exports = { "default": require("core-js/library/fn/number/epsilon"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/number/epsilon.js